if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('textarea');
      this.disclosure = this.closest('details');
      this.cartNoteToggle = this.disclosure?.querySelector('.js-show-note');
      this.savedValue = this.input?.value || '';
      this.addEventListener('input', () => {
        clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => this.save(), 300);
      });
    }

    disconnectedCallback() {
      clearTimeout(this.saveTimer);
      if (this.input?.value !== this.savedValue) this.save();
    }

    async save() {
      clearTimeout(this.saveTimer);
      const value = this.input?.value || '';
      if (value === this.savedValue && !this.pending) return true;
      if (this.pending && this.pendingValue === value) return this.pending;
      this.pendingValue = value;
      const version = this.version = (this.version || 0) + 1;
      theme.clearRequestFeedback(this);
      this.setAttribute('aria-busy', 'true');
      const request = (theme.cartNoteQueue || Promise.resolve()).catch(() => {}).then(async () => {
        const response = await fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: value }),
          keepalive: true
        });
        if (!response.ok) throw new Error(String(response.status));
        await response.json();
        this.savedValue = value;
        if (this.cartNoteToggle) {
          this.cartNoteToggle.textContent = value ? theme.strings.editCartNote : theme.strings.addCartNote;
        }
        return true;
      }).catch(() => {
        if (version === this.version) {
          if (this.disclosure) this.disclosure.open = true;
          theme.requestFeedback(this, { message: theme.strings.noteError, retry: () => this.save() });
        }
        return false;
      }).finally(() => {
        if (version === this.version) {
          this.pending = null;
          this.removeAttribute('aria-busy');
        }
      });
      theme.cartNoteQueue = request;
      this.pending = request;
      return request;
    }
  }
  customElements.define('cart-note', CartNote);

  const dirtyNotes = () => [...document.querySelectorAll('cart-note')]
    .filter((note) => note.pending || note.input?.value !== note.savedValue);
  let proceeding = false;
  let checking = false;
  document.addEventListener('submit', async (event) => {
    if (proceeding || event.submitter?.name !== 'checkout') return;
    const notes = dirtyNotes();
    if (!notes.length) return;
    event.preventDefault();
    if (checking) return;
    checking = true;
    const form = event.target;
    const submitter = event.submitter;
    try {
      if ((await Promise.all(notes.map((note) => note.save()))).every(Boolean)) {
        proceeding = true;
        form.requestSubmit(submitter);
      }
    } finally { proceeding = false; checking = false; }
  }, true);
  document.addEventListener('click', async (event) => {
    if (proceeding || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.target === '_blank') return;
    let url;
    try { url = new URL(link.href, document.baseURI); } catch { return; }
    if (url.origin !== location.origin || url.pathname !== theme.routes.cart) return;
    const notes = dirtyNotes();
    if (!notes.length) return;
    event.preventDefault();
    if (checking) return;
    checking = true;
    try {
      if ((await Promise.all(notes.map((note) => note.save()))).every(Boolean)) {
        proceeding = true;
        link.click();
      }
    } finally { proceeding = false; checking = false; }
  }, true);
}
